/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Lotus Health
 * OpenAPI spec version: 0.0.0
 */

/**
 * `EligibilityStatus` on a `PharmacyEligibility` entry.
 */
export type PharmacyEligibilityStatusT =
  (typeof PharmacyEligibilityStatusT)[keyof typeof PharmacyEligibilityStatusT];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PharmacyEligibilityStatusT = {
  Covered: "Covered",
  NotCovered: "NotCovered",
  OutOfPocket: "OutOfPocket",
  Unknown: "Unknown",
  UnableToProcess: "UnableToProcess",
} as const;
